/* esm.sh - date-fns@4.1.0/_lib/defaultOptions */
var t={};function n(){return t}function o(e){t=e}export{n as getDefaultOptions,o as setDefaultOptions};
//# sourceMappingURL=defaultOptions.mjs.map